import type { CSSProperties } from 'react';

/** Recharts `<Tooltip contentStyle>` — the one tooltip look every chart shares. */
export const CHART_TOOLTIP_STYLE: CSSProperties = {
  fontSize: 12,
  borderRadius: 6,
  backgroundColor: 'hsl(var(--background))',
  border: '1px solid hsl(var(--border))',
  color: 'hsl(var(--foreground))',
  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
};
